import { BorderStyle, BorderThickness } from 'almanac-ui/icons'
import { TableBorderColorPicker } from 'common/Prose/components/TableBorderColorPicker/TableBorderColorPicker'
import { TableBorderStylePicker } from 'common/Prose/components/TableBorderStylePicker/TableBorderStylePicker'
import { TableBorderThicknessPicker } from 'common/Prose/components/TableBorderThicknessPicker/TableBorderThicknessPicker'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { InlineFormatBar } from 'components/InlineFormatBar/InlineFormatBar'
import { InlineFormatButton } from 'components/InlineFormatBar/components/InlineFormatButton/InlineFormatButton'
import { type EditorView } from 'prosemirror-view'
import Styles from './BorderFormatBar.module.scss'
import { ReactComponent as ChevronDown } from 'assets/icons/chevron/xxs-down.svg'
import { useActiveBorderColorsInSelection } from 'common/Prose/hooks/useActiveCellColorsInSelection'
import BorderColor from 'almanac-ui/icons/24/BorderColor'

interface Props {
  view: EditorView
}

export const BorderFormatBar = ({ view }: Props) => {
  const borderColors = useActiveBorderColorsInSelection(view)
  if (!view.editable) return null

  return (
    <InlineFormatBar>
      <DropdownTrigger>
        <InlineFormatButton label="Set border color" data-testid="Set border color">
          <BorderColor style={{ margin: '0 -2px' }} color={borderColors[0]} />
          Color
          <ChevronDown />
        </InlineFormatButton>
        {(close) => <TableBorderColorPicker includeDropdownStyles={false} view={view} closePicker={close} />}
      </DropdownTrigger>

      <DropdownTrigger popoverClassName={Styles.dropdownContainer}>
        <InlineFormatButton label="Set border thickness" data-testid="Set border thickness">
          <BorderThickness />
          Thickness
          <ChevronDown />
        </InlineFormatButton>
        {(close) => <TableBorderThicknessPicker includeDropdownStyles={false} view={view} closePicker={close} />}
      </DropdownTrigger>

      <DropdownTrigger popoverClassName={Styles.dropdownContainer}>
        <InlineFormatButton label="Set border style" data-testid="Set border style">
          <BorderStyle />
          Style
          <ChevronDown />
        </InlineFormatButton>
        {(close) => <TableBorderStylePicker includeDropdownStyles={false} view={view} closePicker={close} />}
      </DropdownTrigger>
    </InlineFormatBar>
  )
}
